import { ModelSagres } from "../model-sagres";
import { ArquivoRespostaAviso } from "./arquivo-resposta-aviso";

export class RespostaAviso extends ModelSagres {
  idResposta: number;
  mensagem: string;
  nomeUsuario: string;
  unidadeGestora: string;
  dataResposta: Date;
  Arquivos: ArquivoRespostaAviso[];

  constructor(obj?: any) {
    super();
    if (obj) {
      this.idResposta = obj.idResposta;
      this.mensagem = obj.mensagem;
      this.nomeUsuario = obj.nomeUsuario;
      this.unidadeGestora = obj.unidadeGestora;
      this.dataResposta = new Date(obj.dataResposta);
      this.Arquivos = obj.Arquivos.map(
        (arquivo: any) => new ArquivoRespostaAviso(arquivo)
      );
    }
  }
}
